import React, { useState } from 'react'
import { DialogBase, PrimaryCta, SecondaryCta } from 'components'

import { useUploadSpecialDocumentMutation } from 'features/students/studentApiSlice'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features/snack-bar/snackSlice'

import { useForm, Controller } from 'react-hook-form'
import {
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Button,
} from '@mui/material'

const documentApiMessages = {
  upload_problem: 'Ocurrio un error tratando de subir el archivo',
  not_valid_file: 'El archivo no es valido',
  incorrect_params: 'Los parametros no son correctos',
  student_not_found: 'El alumno no existe',
  student_not_special: 'El alumno no es caso especial',
  user_or_pass_error: 'Ocurrio un error relacionado con el usuario',
  default: 'Ocurrio un error en la solicitud',
}

export default function UploadSpecialCaseDocumentDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    togglerProps = {},
    children,
    studentid,
    addDocument,
  } = _props

  const [open, setOpen] = useState(false)
  const [fileName, setFileName] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const dispatch = useDispatch()

  const [fileError, setFileError] = useState('')

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm()

  const clearForm = () => {
    setFileName('')
    reset({
      label: '',
      file: '',
      fileType: 'creacion',
    })
  }

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    clearForm()
    setOpen(false)
  }

  const [uploadSpecialDocument] = useUploadSpecialDocumentMutation()

  async function onSubmit(data) {
    if (!data.file) {
      setFileError('This field cannot be empty')
      return // prevent form submission
    }

    setIsSubmitting(true)
    try {
      const result = await uploadSpecialDocument({
        studentid: studentid,
        filename: data.name,
        type: data.fileType,
        file: data.file,
      })

      if (!result.error) {
        dispatch(
          successSnack({
            message: `${data.name} fue cargado correctamente`,
          })
        )

        const allDocuments = result?.data?.documents || []
        const newDocument = allDocuments[allDocuments.length - 1]

        if (!newDocument || data.name !== newDocument.name) {
          throw new Error('newDocument is undefined')
        }

        addDocument({
          documentid: newDocument.documentid,
          name: data.name,
          type: data.fileType,
          fileurl: newDocument.fileurl,
        })

        closeDialog()
      } else {
        const key =
          result?.data?.message || result?.error?.data?.message || 'default'
        dispatch(
          errorSnack({
            message: documentApiMessages[key] || documentApiMessages['default'],
          })
        )
      }
    } catch (e) {
      dispatch(errorSnack({ message: documentApiMessages[e?.data?.message] }))
      closeDialog()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogBase
          title="Cargar Documento"
          titleAlignment="center"
          open={open}
          handleClose={closeDialog}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col mb-10 mt-10">
              <Controller
                name="name"
                control={control}
                defaultValue=""
                rules={{ required: 'This field is required' }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    id="name-input"
                    label="Nombre"
                    InputLabelProps={{
                      shrink: true,
                      style: { fontSize: '1.5rem', top: '-5px', left: '-13px' },
                    }}
                    error={!!errors.name}
                    helperText={errors.name ? errors.name.message : null}
                  />
                )}
              />
            </div>
            <div className="flex flex-col mb-10 items-baseline">
              <label htmlFor="file-input" className="inline">
                Upload File
              </label>
              <Controller
                name="file"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <div>
                    <Button variant="contained" component="label">
                      Upload File
                      <input
                        id="file-input"
                        type="file"
                        hidden
                        onChange={(e) => {
                          field.onChange(e.target.files[0])
                          setFileName(e.target.files[0].name)
                          setFileError('')
                        }}
                      />
                    </Button>
                    {fileError ? (
                      <p className="text-red-500">{fileError}</p>
                    ) : null}
                    <p>{fileName}</p>
                  </div>
                )}
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="file-type-input">File Type</label>
              <div className="ml-4">
                <FormControl component="fieldset" error={!!errors.fileType}>
                  <FormLabel component="legend"></FormLabel>
                  <Controller
                    id="file-type-input"
                    name="fileType"
                    control={control}
                    defaultValue="c"
                    rules={{ required: 'This field is required' }}
                    className="mr-5"
                    render={({ field }) => (
                      <RadioGroup {...field}>
                        <FormControlLabel
                          value="c"
                          control={<Radio />}
                          label="Creacion"
                        />
                        <FormControlLabel
                          value="l"
                          control={<Radio />}
                          label="Liquidacion"
                        />
                      </RadioGroup>
                    )}
                  />
                </FormControl>
              </div>
            </div>
            <div className="flex flex-row justify-center gap-4 w-full mt-10">
              <SecondaryCta disabled={isSubmitting} onClick={closeDialog}>
                Cerrar
              </SecondaryCta>
              <PrimaryCta isSubmitting={isSubmitting} type="submit">
                Confirmar
              </PrimaryCta>
            </div>
          </form>
        </DialogBase>
      )}
    </>
  )
}
